import parseCookie from '../utils/parseCookie';
import isNode from '../utils/isNode';

export default function (ctx) {
    const cookie = parseCookie((!isNode ? document.cookie : ctx.req.headers.cookie) || '');
    if (cookie.USER_TOKEN && cookie.USER_UID) {
        ctx.store.commit('setAuth', {
            auth: {
                token: cookie.USER_TOKEN,
                uid: cookie.USER_UID,
            },
        });
    }
}
